import { SensorDataPoint } from '@Types';

export const convertToPoint = (
	timestampInSeconds: number,
	value: number,
): SensorDataPoint => {
	return {
		timestamp: {
			timestamp: new Date(timestampInSeconds).toISOString(),
			timeInSeconds: timestampInSeconds,
		},
		value: {
			doubleValue: value,
			unit: 'unit',
		},
	};
};

export const filterDuplicateSensorDataPoints = (
	sensorData: SensorDataPoint[],
): SensorDataPoint[] => {
	const uniqueTimestampsSet = new Set<number>();
	return sensorData.filter(point => {
		if (uniqueTimestampsSet.has(point.timestamp.timeInSeconds)) {
			return false;
		}
		uniqueTimestampsSet.add(point.timestamp.timeInSeconds);
		return true;
	});
};

export default filterDuplicateSensorDataPoints;
